// THIS HANDLES THE FEATURED PROS CARDS ACCORDION FUNCTIONALITY FOR MOBILE
jQuery(document).ready(function ($) {
    function featuredProsMobileAccordion() {
        $('.featured-pros-card-row').each(function () {
            let cardRow = $(this);

            // If .no-collapse is present, ensure all items remain expanded
            if (cardRow.hasClass('no-collapse')) {
                cardRow
                    .find(
                        '.featured-pros-card .fpc-image, .featured-pros-card .fpc-desc, .featured-pros-card .fpc-cta'
                    )
                    .show();
                return; // Skip accordion behavior for this row
            }

            if ($(window).width() < 768) {
                cardRow
                    .find('.featured-pros-card')
                    .off('click')
                    .on('click', function () {
                        let clickedCard = $(this);

                        if (clickedCard.hasClass('expanded')) {
                            clickedCard
                                .find('.fpc-image, .fpc-desc, .fpc-cta')
                                .slideUp();
                            clickedCard.removeClass('expanded');
                            return;
                        }

                        // Collapse all other cards in this row only
                        cardRow
                            .find('.featured-pros-card')
                            .not(clickedCard)
                            .find('.fpc-image, .fpc-desc, .fpc-cta')
                            .slideUp();
                        cardRow
                            .find('.featured-pros-card')
                            .not(clickedCard)
                            .removeClass('expanded');

                        // Expand clicked card
                        clickedCard
                            .find('.fpc-image, .fpc-desc, .fpc-cta')
                            .slideDown();
                        clickedCard.addClass('expanded');
                    });
            } else {
                // Reset all cards on larger screens
                cardRow
                    .find('.featured-pros-card')
                    .off('click')
                    .removeClass('expanded');
                cardRow.find('.fpc-image, .fpc-desc, .fpc-cta').show();
            }
        });
    }

    featuredProsMobileAccordion();

    // Reapply the functionality when the window is resized
    $(window).resize(function () {
        featuredProsMobileAccordion();
    });
});
/////////////////////////////////

// THIS HANDLES ADDING EXTRA SPACING ABOVE THE FIRST IMAGE BOX ELEMENT OF A TWO COLUMN SECTION AND THE LAST ELEMENT
document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.tcsr-left');
    if (!container) return;
    const imageBoxes = container.querySelectorAll(
        '.elementor-widget-image-box'
    );

    if (imageBoxes.length > 0) {
        imageBoxes[0].classList.add('first-image-box'); // Add class to first
        imageBoxes[imageBoxes.length - 1].classList.add('last-image-box'); // Add class to last
    }
});
/////////////////////////////////

//THE BELOW CODE CUSTOMIZES THE ELEMENTOR TABS ON MOBILE. BY DEFAULT THE TABS ON MOBILE TRUN INTO AN ACCORDION
//THIS OVERRIDES THAT FUNCTION AND PUTS THEM IN A DROP DOWN SELECTOR
document.addEventListener('DOMContentLoaded', function () {
    const tabsContainer = document.querySelector('.e-n-tabs');
    const tabButtonsContainer = document.querySelector('.e-n-tabs-heading');

    if (!tabsContainer || !tabButtonsContainer) return;

    const tabButtons = tabButtonsContainer.querySelectorAll('.e-n-tab-title');
    const tabContents = document.querySelectorAll('.e-n-tabs-content > div');

    function isMobile() {
        return window.innerWidth <= 768;
    }

    function createCustomDropdown() {
        if (!tabsContainer) return;

        // Create dropdown wrapper
        const dropdownWrapper = document.createElement('div');
        dropdownWrapper.classList.add('custom-dropdown');

        // Create dropdown button
        const dropdownBtn = document.createElement('button');
        dropdownBtn.classList.add('dropdown-btn');
        dropdownBtn.textContent =
            tabButtonsContainer
                .querySelector("[aria-selected='true']")
                ?.textContent.trim() || 'Select a tab';

        // Create dropdown menu
        const dropdownMenu = document.createElement('ul');
        dropdownMenu.classList.add('dropdown-menu');
        dropdownMenu.style.display = 'none';

        // Populate dropdown with tab options
        tabButtons.forEach((button) => {
            const listItem = document.createElement('li');
            listItem.textContent = button.textContent.trim();
            listItem.setAttribute(
                'data-tab-index',
                button.getAttribute('data-tab-index')
            );

            // Add click event to switch tabs
            listItem.addEventListener('click', function () {
                dropdownBtn.textContent = this.textContent;
                switchTab(this.getAttribute('data-tab-index'));
                dropdownMenu.style.display = 'none'; // Close dropdown after selection
            });

            dropdownMenu.appendChild(listItem);
        });

        // Append elements
        dropdownWrapper.appendChild(dropdownBtn);
        dropdownWrapper.appendChild(dropdownMenu);
        tabsContainer.insertBefore(dropdownWrapper, tabButtonsContainer);

        // Hide tab buttons on mobile
        tabButtonsContainer.style.display = 'none';

        // Show/hide dropdown menu
        dropdownBtn.addEventListener('click', function () {
            //dropdownMenu.style.display = dropdownMenu.style.display === "block" ? "none" : "block";
            const isOpen = dropdownMenu.style.display === 'block';
            dropdownMenu.style.display = isOpen ? 'none' : 'block';

            // Toggle 'active' class on the button
            dropdownBtn.classList.toggle('active');
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function (event) {
            if (!dropdownWrapper.contains(event.target)) {
                dropdownMenu.style.display = 'none';
            }
        });
    }

    function switchTab(index) {
        // Remove active classes
        tabButtons.forEach((btn) => btn.setAttribute('aria-selected', 'false'));
        tabContents.forEach((content) => content.classList.remove('e-active'));

        // Activate selected tab
        const activeButton = document.querySelector(
            `.e-n-tab-title[data-tab-index="${index}"]`
        );
        const activeContent = document.querySelector(
            `.e-n-tabs-content > div[data-tab-index="${index}"]`
        );

        if (activeButton) activeButton.setAttribute('aria-selected', 'true');
        if (activeContent) activeContent.classList.add('e-active');
    }

    // Run on mobile only
    if (isMobile()) {
        createCustomDropdown();
    }

    // Update on window resize
    window.addEventListener('resize', function () {
        if (isMobile() && !document.querySelector('.custom-dropdown')) {
            createCustomDropdown();
        } else if (!isMobile() && document.querySelector('.custom-dropdown')) {
            document.querySelector('.custom-dropdown').remove();
            tabButtonsContainer.style.display = 'flex'; // Show tabs again
        }
    });
});
/////////////////////////////////

//THE FOLLOWING SCRIPT HANDLED THE MOBILE FUNCTIONALITY OF THE MOEN SKILLS TABLE, ADDING IN THE DROP DOWN FUNCTION
document.addEventListener('DOMContentLoaded', function () {
    function transformTableForMobile() {
        if (window.innerWidth >= 768) return; // Run only on mobile

        const table = document.querySelector('.moen-rank-table');
        if (!table) return;

        const tableContainer = table.parentNode;
        const headers = table.querySelectorAll('th');
        const rows = table.querySelectorAll('tr');

        // Create accordion container
        const accordionContainer = document.createElement('div');
        accordionContainer.classList.add('moen-rank-table-accordion');

        headers.forEach((header, index) => {
            if (header.classList.contains('blank')) {
                // Hide the blank header
                header.style.display = 'none';
                return;
            }

            // Create the toggle button for each category
            const categoryToggle = document.createElement('div');
            categoryToggle.classList.add('accordion-header', header.className);
            categoryToggle.innerHTML = `
              <img src="${header.querySelector('img').src}" alt="">
              <span>${header.innerHTML.replace(/<img[^>]+>/, '')}</span>
          `;

            // Create the collapsible content wrapper
            const categoryContent = document.createElement('div');
            categoryContent.classList.add('accordion-content');
            categoryContent.style.maxHeight = '0px'; // Set initial state
            categoryContent.style.overflow = 'hidden';
            categoryContent.style.transition = 'max-height 0.3s ease-out';

            // Populate content with corresponding table cells
            rows.forEach((row) => {
                const headCol = row.querySelector('.headcol');
                const dataCell = row.cells[index];

                if (headCol && dataCell) {
                    const rowWrapper = document.createElement('div');
                    rowWrapper.classList.add('accordion-row');

                    rowWrapper.innerHTML = `
                      <div class="accordion-label">${headCol.innerHTML}</div>
                      <div class="accordion-value">${dataCell.innerHTML}</div>
                  `;

                    categoryContent.appendChild(rowWrapper);
                }
            });

            // Toggle event listener with slide animation
            categoryToggle.addEventListener('click', function () {
                const isOpen = categoryContent.style.maxHeight !== '0px';

                // Close all open accordions before opening another (Optional)
                document
                    .querySelectorAll('.accordion-content')
                    .forEach((content) => {
                        content.style.maxHeight = '0px';
                        content.previousElementSibling.classList.remove(
                            'active'
                        );
                    });

                // Toggle the clicked one
                if (!isOpen) {
                    categoryContent.style.maxHeight =
                        categoryContent.scrollHeight + 'px';
                    categoryToggle.classList.add('active');
                } else {
                    categoryContent.style.maxHeight = '0px';
                    categoryToggle.classList.remove('active');
                }
            });

            // Append elements to accordion container
            accordionContainer.appendChild(categoryToggle);
            accordionContainer.appendChild(categoryContent);
        });

        // Replace the original table with the accordion
        table.style.display = 'none';
        tableContainer.appendChild(accordionContainer);
    }

    transformTableForMobile();
});
/////////////////////////////////

//SEARCH TOGGLE IN HEADER
//this part handles the toggle on and off to show the search bar
document.addEventListener('DOMContentLoaded', function () {
    const searchToggles = document.querySelectorAll('.moen-search-toggle');
    const searchElements = document.querySelectorAll('.e-search');

    if (searchToggles.length === 0 || searchElements.length === 0) return; // Prevent errors if elements are missing

    searchToggles.forEach((toggle, index) => {
        toggle.addEventListener('click', function () {
            // Ensure we target the corresponding .e-search
            const searchElement = searchElements[index];
            if (!searchElement) return;

            searchElement.classList.toggle('active');
            toggle.classList.toggle('close');
        });
    });
});
//this part dynamically adjusts the search bar width because we want it to always cover the menu
document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.header'); // Get all headers

    function updateCSSVariables() {
        headers.forEach((header) => {
            const moenMainNav = header.querySelector('.moen-main-nav');
            const moenSearchToggle = header.querySelector(
                '.moen-search-toggle'
            );

            if (moenMainNav && moenSearchToggle) {
                // Get the left offsets of the elements
                const moenMainNavLeft =
                    moenMainNav.getBoundingClientRect().left;
                const moenSearchToggleLeft =
                    moenSearchToggle.getBoundingClientRect().left;

                // Set custom properties on the header
                header.style.setProperty(
                    '--moen-main-nav-left',
                    `${moenMainNavLeft}px`
                );
                header.style.setProperty(
                    '--moen-search-toggle-left',
                    `${moenSearchToggleLeft}px`
                );
                header.style.setProperty(
                    '--e-search-width',
                    `${moenSearchToggleLeft - moenMainNavLeft}px`
                );
            }
        });
    }

    // Initial update
    updateCSSVariables();

    // Update on window resize to maintain responsiveness
    window.addEventListener('resize', updateCSSVariables);
});
/////////////////////////////////

//BELOW ADDS THE EXTRA BUTTONS AND SEARCH TO THE MOBILE MENU DROP DOWNS
document.addEventListener('DOMContentLoaded', function () {
    function addMobileExtra(navId, isLoggedOut = true) {
        const mobileNav = document.querySelector(
            `${navId} nav.elementor-nav-menu--dropdown`
        );
        const menuList = mobileNav
            ? mobileNav.querySelector('ul.elementor-nav-menu')
            : null;

        if (!mobileNav || !menuList) return;

        // Check if a `.mobile-extra` already exists inside this specific nav
        if (!mobileNav.querySelector('.mobile-extra')) {
            const extraDiv = document.createElement('div');
            extraDiv.classList.add('mobile-extra');

            // Create search form dynamically
            const searchForm = document.createElement('form');
            searchForm.classList.add('mobile-search-form');
            searchForm.setAttribute('action', window.location.origin);
            searchForm.setAttribute('method', 'get');
            searchForm.innerHTML = `
              <input type="search" name="s" placeholder="Search" required>
              <button type="submit"></button>
          `;

            const wpLogoutUrl =
                '<?php echo esc_url( wp_logout_url( home_url() ) ); ?>';
            // Create Login or Logout button
            const authBtn = document.createElement('a');
            authBtn.classList.add('mob-login-btn');
            authBtn.href = isLoggedOut ? '/login/' : wpLogoutUrl; // Replace with actual logout URL later
            authBtn.textContent = isLoggedOut ? 'Login' : 'Log Out';

            // Append elements
            extraDiv.appendChild(searchForm);
            extraDiv.appendChild(authBtn);

            // Add "Join the Club" button ONLY for logged-out users
            if (isLoggedOut) {
                const joinBtn = document.createElement('a');
                joinBtn.classList.add('mob-jtc-btn');
                joinBtn.href = '/register';
                joinBtn.textContent = 'Join the Club';
                extraDiv.appendChild(joinBtn);
            }

            // Insert after the <ul class="elementor-nav-menu">
            menuList.parentNode.insertBefore(extraDiv, menuList.nextSibling);
        }
    }

    // Run the function for both navs
    function initializeMobileExtras() {
        addMobileExtra('#loggedout-nav', true); // Logged-out: "Login" & "Join the Club"
        addMobileExtra('#loggedin-nav', false); // Logged-in: "Log Out"
    }

    initializeMobileExtras(); // Run on page load

    // Observe for dynamic changes (if Elementor regenerates menu)
    const observer = new MutationObserver(() => {
        initializeMobileExtras();
    });

    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
});
/////////////////////////////////

//BELOW HANDLES CUSTOMIZATION OF THE REGISTRATION FORM

/////////////////////////////////

/////////////////////////////////
//Some functionality for Account settings page form
/////////////////////////////////

const fileUpload = (event) => {
    const files = event.target.files;
    const filesLength = files.length;
    if (filesLength > 0) {
        const imageSrc = URL.createObjectURL(files[0]);
        const imagePreviewElement = document.querySelector('#img_path');

        // Create a text node instead of using innerHTML to prevent HTML injection
        const textNode = document.createTextNode(files[0].name);
        imagePreviewElement.innerHTML = ''; // Clear existing content
        imagePreviewElement.appendChild(textNode);

        var output = document.getElementById('profile_img');
        output.src = URL.createObjectURL(event.target.files[0]);
        document.querySelector('#delete_image').value = 'false';
    }
};

const toggDelete = (event) => {
    let deleteTogg = document.querySelector('#delete_image').value;
    let defaultImg = document.querySelector('#default_img');
    let userImg = document.querySelector('#profile_img');
    let deleteBtn = document.querySelector('#delete_img_avatar');

    let toggler = false;
    if (deleteTogg === 'true') {
        toggler = 'false';
        if (userImg.classList.contains('hide_pict')) {
            userImg.classList.remove('hide_pict');
            defaultImg.classList.add('hide_pict');
        }
    } else {
        toggler = 'true';
        if (defaultImg.classList.contains('hide_pict')) {
            defaultImg.classList.remove('hide_pict');
            userImg.classList.add('hide_pict');
        }

        if (!deleteBtn.classList.contains('disable_btn')) {
            deleteBtn.classList.add('disable_btn');
        }
    }

    document.querySelector('#delete_image').value = toggler;
};

//TOGGLES THE LOGIN FORMS
jQuery(document).ready(function () {
    // Set initial state
    jQuery('#credentials').show();
    jQuery('#direct').hide();
    jQuery('#credential-btn').addClass('active');

    // Click event for Credential button
    jQuery('#credential-btn').click(function () {
        jQuery('#credentials').show();
        jQuery('#direct').hide();
        jQuery('#credential-btn').addClass('active');
        jQuery('#direct-btn').removeClass('active');
    });

    // Click event for Direct button
    jQuery('#direct-btn').click(function () {
        jQuery('#direct').show();
        jQuery('#credentials').hide();
        jQuery('#direct-btn').addClass('active');
        jQuery('#credential-btn').removeClass('active');
    });
});
